import * as React from 'react';
import cx from 'classnames';
import ShareModalStore from '@src/business-components/share-modal/store';
import wrapStore from '@src/utils/wrap-store';
import ModalContainer from '@src/components/modal-container';
import Link from '@src/components/link';

const styles = require('./index.less');

/**
 * 分享弹窗
 * @param {ShareModalStore} store
 * @param onClose
 * @return {JSX.Element}
 * @constructor
 */
const ShareModal = ({ store, onClose }) => {
  store.use();
  if (onClose) {
    store.onClose = onClose;
  }

  return (
    <ModalContainer modalState={store.isOpen}>
      <div className={cx(styles.shareModalRoot)}>
        {/* <div className={styles.title} /> */}
        <div className={styles.content}>
          <div className={styles.shareList}>
            {store.shareConfig.map(item => <img key={item.key} src={item.icon} alt="" className={styles.shareItem} onClick={item.onShare} />)}
          </div>
          选择上方任意渠道分享
        </div>
        <Link className={cx(styles.close)} onClick={store.onClickClose} />
      </div>
    </ModalContainer>
  );
};

export default wrapStore(ShareModal, ShareModalStore);
